import { fetchMainApi } from '@/api'

export const getStates = async () => {
  return fetchMainApi('GET', '/states')
}

export const getCities = async (stateId) => {
  return fetchMainApi('GET', `/states/${stateId}/cities`)
}

export const searchLoc = async (query, limit = 10) => {
  return fetchMainApi('GET', `https://new.api.nexusautotransport.com/api/locations?q=${encodeURIComponent(query)}`)
}

export const searchCities = searchLoc

export const getAreas = async (areaType) => {
  return fetchMainApi('GET', `/areas?type=${areaType}`)
}

export const getLocationByCoordinates = async (lat, lng) => {
  return fetchMainApi('GET', `/locations/reverse?lat=${lat}&lng=${lng}`)
}
